


















































































import Vue from 'vue'
import models from '@/mixins/models-mixin'
import { mapGetters } from 'vuex'
import IList from '@/types/components/IList.interface'
import { CampaignParams } from '@/types/PaginationParams.interface'
import IListTile from '@/types/components/IListTile.interface'
import Campaign from '@/types/Campaign.interface'
import FilterButton from '@/components/FilterButton.vue'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, {
    IListBadge,
    IListIconType
} from '@/types/components/IListIcon.interface'
import Button from '@/types/components/Button.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import Group from '@/types/Group.interface'
import { CampaignFilterParams } from '@/types/FilterParams.interface'
import moment from 'moment-timezone'
import SmsInboundBubble from '@/components/SmsInboundBubble.vue'
import SmsOutboundBubble from '@/components/SmsOutboundBubble.vue'
export default Vue.extend({
    mixins: [models],
    components: { FilterButton, SmsInboundBubble, SmsOutboundBubble },
    data() {
        return {
            //  Our placeholder for our ilist
            campaignsListPlaceholder: {
                content: 'No Campaigns Found'
            },
            //  Our filter bound to the list for filtering active or paused autoresponders
            filter: {
                selected: {
                    display: 'All',
                    key: 'type',
                    value: 'all',
                    selection: 'All'
                },
                options: [
                    {
                        display: 'All',
                        key: 'type',
                        value: 'all',
                        selection: 'All'
                    },
                    {
                        display: 'Active',
                        key: 'type',
                        value: 'active',
                        color: 'primary'
                    },
                    {
                        display: 'Paused',
                        key: 'type',
                        value: 'paused',
                        color: '#E7A730'
                    }
                ]
            },
            //  Determines if we have finished mounting or not
            mounted: false,
            //  The toolbar displayed above the tri-panel
            toolbar: {
                title: 'Autoresponders',
                help: {
                    title: 'Text Message Campaign Builder',
                    body: 'Set up "Keywords" contacts can message you with that trigger automatic text message replies from your MessageDesk account. Great for conversation automation and enabling contacts to "self-help". Check out the article below for more tips on how to use Autoresponders',
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/4662511-autoresponders-overview`
                    }
                },
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/home',
                        tooltip: 'Back',
                        permission: 0
                    }
                ],
                right: []
            }
        }
    },
    beforeDestroy() {
        //  Unset our selected campaign and it should also unset the group
        this.selectedCampaign = null
    },
    mounted() {
        //  Check if a campaign is set in the url params
        const id = this.$route.query.id

        //  If a campaign id is set, load it
        if (id) this.$store.dispatch('autorespondersSelectedCampaignGet', id)

        //  Find the filter that matches the current param
        const selected = this.filter.options.find(
            (x) => x.value === this.campaignsParams.type
        )

        //  Set this as the new selected
        this.filter.selected = selected

        //  Set mounted to true to tell our component we are ready
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            campaigns: 'autorespondersCampaigns',
            campaignsParamsDefault: 'autorespondersCampaignsParamsDefault',
            lastPage: 'autorespondersCampaignsLastPage',
            paginating: 'autorespondersCampaignsPaginating',
            scrollPositionLeft: 'scrollPositionLeft',
            tenant: 'tenant',
            user: 'user'
        }),
        active(): boolean {
            //  Grab our filter value
            const filter = this.filter.selected.value

            //  If filter is active, return true
            if (filter === 'active') return true

            //  Else, if filter is paused, return false
            if (filter === 'paused') return false

            //  If we have no campaigns ilist then return true
            if (!this.campaignsIList) return true

            //  Else, grab our selected campaigns
            const items = this.campaignsIList.multiSelected

            //  If the items are empty, return true
            if (!items || !items.length) return true

            //  Else, filter out any that might be paused
            const filtered = items.filter((x: Campaign) => x.paused !== null)

            //  If the filtered length is greater than 0, it means we have paused, so return false
            return filtered.length === 0
        },
        button(): object {
            //  If we have no campaigns ilist then return null
            if (!this.campaignsIList) return null

            //  Get our total selected campaigns
            const items = this.campaignsIList.multiSelected

            //  If nullish then return new autoresponder styles
            if (!items || !items.length)
                return { color: 'primary', text: 'New Autoresponder', icon: 'mdi-plus' }

            //  Else, if we are paused then return paused styles
            if (this.paused)
                return {
                    color: this.$colors.mdYellow,
                    text: 'Delete',
                    icon: 'bi-trash-fill'
                }

            //  Else, return our default styles for deleting
            return { color: 'black', text: 'Pause', icon: 'mdi-pause' }
        },
        campaignsEnabled(): boolean {
            // return this.$store.getters.getEnabled('autoresponder')
            return true
        },
        campaignsIList(): IList {
            return this.$store.getters.iList('autorespondersCampaignsList')
        },
        campaignsParams: {
            get(): CampaignParams {
                return this.$store.getters.autorespondersCampaignsParams
            },
            set(val: CampaignParams): void {
                this.$store.commit('autorespondersCampaignsParamsSet', val)
            }
        },
        campaignCount() {
            return this.$store.getters.campaignCount
        },
        campaignLimit() {
            //  Get our limit
            return this.$store.getters.getLimit('autoresponder') || Infinity
        },
        //  Tells us if we have modified the filter in any sort of way
        filterModified(): boolean {
            //  Get the default pagination params
            const defaults = this.campaignsParamsDefault

            //  Get the current params
            const params = this.campaignsParams

            //  Determine if we have modified it at all
            const isModified = !window._.isEqual(defaults, params)

            //  Return our result
            return isModified
        },
        keyword() {
            //  If no selected campaign, return null
            if (!this.selectedCampaign) return null

            // Text shown in gray sms bubble
            return {
                text: `<b>Keyword:</b> "${this.selectedCampaign.subscribe}"`,
                type: 'autoresponder'
            }
        },
        keywordMsg() {
            //  If no selected campaign, return null
            if (!this.selectedCampaign) return null

            // Text shown in black sms bubble
            return {
                text: `<b>Keyword Message:</b><br>"${this.selectedCampaign.subscribe_message}"`,
                media: this.selectedCampaign.subscribe_media,
                type: 'autoresponder'
            }
        },
        //  Returns an array of multi-selected campaignIds
        multiSelectedCampaignIds(): string[] {
            //  If the campaignsIList does NOT exist, return empty array
            if (!this.campaignsIList) return []

            //  Assemble an array of multi-selected campaign ids
            const ids = this.campaignsIList.multiSelected.map(
                (campaign: Campaign) => campaign.id
            )

            //  Return the campaign ids
            return ids
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        optOutKeyword() {
            //  If no selected campaign, return null
            if (!this.selectedCampaign) return null

            // Text shown in gray sms bubble
            return {
                text: `<b>Opt-Out Keyword:</b> "${this.selectedCampaign.unsubscribe}"`,
                type: 'autoresponder'
            }
        },
        optOutPreview() {
            //  If no selected campaign, return null
            if (!this.selectedCampaign) return null

            // Text shown in black sms bubble
            return {
                text: `<b>Opt-Out Preview</b><br> "${this.selectedCampaign.unsubscribe_message}"`,
                media: this.selectedCampaign.unsubscribe_media,
                type: 'autoresponder'
            }
        },
        paused(): boolean {
            //  Grab our filter value
            const filter = this.filter.selected.value

            //  If filter is active, return true
            if (filter === 'paused') return true

            //  Else, if filter is paused, return false
            if (filter === 'active') return false

            //  Else, grab our selected campaigns
            const items = this.campaignsIList.multiSelected

            //  If the items are empty, return true
            if (!items || !items.length) return true

            //  Else, filter out any that might be paused
            const filtered = items.filter((x: Campaign) => x.paused === null)

            //  If the filtered length is greater than 0, it means we have paused, so return false
            return filtered.length === 0
        },
        //  The camnpaign selected in the IList
        selectedCampaign: {
            get(): Campaign {
                return this.$store.getters.autorespondersSelectedCampaign
            },
            set(val: Campaign): void {
                this.$store.commit('autorespondersSelectedCampaignSet', val)
            }
        },
        //  the group bound to the selected campaign
        selectedGroup: {
            get(): Group {
                return this.$store.getters.autorespondersSelectedGroup
            },
            set(val: Group): void {
                this.$store.commit('autorespondersSelectedGroupSet', val)
            }
        },
        showPaywall(): boolean {
            //  Grab our campaigns
            const campaigns = this.campaigns

            //  Get the total number of campaigns
            const total = campaigns.length

            //  If we have null OR if the total is 0, return true
            if (!campaigns || !total) return true

            //  Else, get the number of required campaigns (if they changed the name, they're good)
            const required = campaigns.filter(
                (x: Campaign) => x.name === 'Subscribed Contacts'
            )

            //  If we our required and total are the same length, return true
            if (required.length === total) return true

            //  Else, we return false
            return false
        }
    },
    methods: {
        campaignActions(campaign: Campaign): IListAction {
            //  Create our buttons menu
            const menu: Button[] = [
                {
                    icon: 'mdi-account-multiple',
                    color: 'primary',
                    text: 'Go To Group',
                    callback: () => this.goToGroup(campaign)
                },
                {
                    icon: 'bi-trash-fill',
                    text: 'Delete Autoresponder',
                    color: 'red',
                    hidden: campaign.required,
                    callback: () => this.campaignDeleteConfirm(campaign)
                }
            ]

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  return all actions
            return action
        },
        async campaignCreate(campaign: Campaign): Promise<void> {
            //  Send the post request to the API
            const created = await this.$store.dispatch('campaignsPost', campaign)

            //  If the request failed, do nothing
            if (!created) return

            //  Else, close the dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Notify user of successful update
            this.$store.commit('appNotificationBarSet', {
                message: 'Autoresponder Created'
            })
        },
        async campaignDelete(result: boolean, campaign: Campaign): Promise<void> {
            //  If the user answered 'NO' in the dialog, do nothing
            if (!result) return

            //  Else, send the DELETE request to the API
            const deleted = await this.$store.dispatch('campaignsDelete', campaign.id)

            //  If the request failed, do nothing
            if (!deleted) return

            //  Else, notify user of successful delete
            this.$store.commit('appNotificationBarSet', {
                message: 'Autoresponder Deleted'
            })
        },
        async campaignDeleteBatch(result: boolean): Promise<void> {
            //  If the user answered 'NO' in the dialog, do nothing
            if (!result) return

            //  Our payload consists of ids we want to delete
            const ids = this.multiSelectedCampaignIds

            //  Send our request
            const deleted = await this.$store.dispatch('campaignsDeleteBatch', ids)

            //  If the request failed, do nothing
            if (!deleted) return

            //  Else, notify user of successful delete
            this.$store.commit('appNotificationBarSet', {
                message: 'Autoresponders Deleted'
            })

            //  Deselect multiselected items
            this.$refs.campaignsList.multiSelectReset()
        },
        campaignDeleteBatchConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Confirm Deletion',
                text: `You are about to delete ${this.multiSelectedCampaignIds.length} autoresponders. Do you want to continue?`,
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true,
                callback: (response: boolean): void => this.campaignDeleteBatch(response)
            })
        },
        campaignDeleteConfirm(campaign: Campaign): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Autoresponder?',
                text: `Are you sure you want to delete this Autoresponder? [<b>${campaign.subscribe.toUpperCase()}</b>]`,
                icon: 'mdi-alert',
                color: 'red darken-2',
                callback: (result: boolean): void => this.campaignDelete(result, campaign)
            })
        },
        campaignIcon(campaign: Campaign): IListIcon {
            //  We use the same icon for every campaign
            const icon = 'bi-lightning-fill'

            //  Create our IListBadge
            const badge: IListBadge = {
                color: 'primary',
                icon: 'mdi-lock'
            }

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                badge: campaign.required ? badge : null,
                content: icon,
                color: 'primary'
            }

            //  Return our IListIcon object
            return listIcon
        },
        async campaignPause(): Promise<void> {
            //  Grab the selected campaign
            const campaign = this.selectedCampaign

            //  Pause the campaign
            campaign.paused = moment.utc().format('Y-MM-DD HH:mm:ss')

            //  Update the campaign
            await this.campaignUpdate(campaign)
        },
        async campaignPauseBatch(): Promise<void> {
            //  Current datetime string
            const now = moment.utc().format('Y-MM-DD HH:mm:ss')

            //  Our payload consists of just the ids and the values we want to insert
            const payload = {
                campaign_ids: this.multiSelectedCampaignIds,
                values: { paused: now }
            }

            //  Update them
            await this.campaignUpdateBatch(payload)
        },
        async campaignResume(): Promise<void> {
            //  Grab the selected campaign
            const campaign = this.selectedCampaign

            //  Resume the paused campaign
            campaign.paused = null

            //  Update the campaign
            await this.campaignUpdate(campaign)
        },
        async campaignResumeBatch(): Promise<void> {
            //  Our payload consists of just the ids and the values we want to insert
            const payload = {
                campaign_ids: this.multiSelectedCampaignIds,
                values: { paused: null }
            }

            //  Update them
            await this.campaignUpdateBatch(payload)
        },
        async campaignUpdate(campaign: Campaign): Promise<void> {
            //  Send the PUT request to the API
            const updated = await this.$store.dispatch('campaignsPut', campaign)

            //  If the request failed, do nothing
            if (!updated) return

            //  Else, close the app dialog
            this.$store.dispatch('dialogClose', 'APP')
        },
        async campaignUpdateBatch(payload: object): Promise<void> {
            //  Send our request
            const updated = await this.$store.dispatch('campaignsPutBatch', payload)

            //  If the request failed, do nothing
            if (!updated) return

            //  Notify user of successful update
            this.$store.commit('appNotificationBarSet', {
                message: 'Autoresponders Updated'
            })

            //  Deselect multiselected items
            this.$refs.campaignsList.multiSelectReset()
        },
        goToGroup(campaign: Campaign): void {
            this.$router.push(`/groups/${campaign.group_id}?sender=${this.$route.path}`)
        },
        handleAutoButton(): void {
            //  If we have no campaigns ilist then return the new autoresponder workflow
            if (!this.campaignsIList) return this.popNewAutoResponder()

            //  Get our total selected campaigns
            const items = this.campaignsIList.multiSelected

            //  If no items are selected then we are just creating a new autoresponder
            if (!items || !items.length) return this.popNewAutoResponder()

            //  IF we are in a paused state, we want to mass delete
            if (this.paused) return this.campaignDeleteBatchConfirm()

            //  Else, we want to mass pause
            return this.campaignPauseBatch()
        },
        newAutoResponse(): Campaign {
            //  get the currently authenticated user
            const user = this.user

            //  If a user does NOT exist, throw error
            if (!user) throw 'A user is requred to create a new auto response'

            //  Get the current tenant
            const tenant = this.tenant

            //  If the tenant does NOT exist, throw error
            if (!tenant) throw 'A tenant is required to create a new auto response'

            //  Else, return a empty campaign model
            return {
                object: 'Campaign',
                type: 'auto_response',
                tenant_id: tenant.id,
                author_id: user.id,
                group_id: null,
                name: null,
                description: null,
                subscribe: null,
                subscribe_message: null,
                unsubscribe: null,
                unsubscribe_message: null,
                paused: null,
                required: false,
                schedules: null
            }
        },
        onCampaignSelected(campaign: Campaign): void {
            //  Set the step to 2 (for mobile layout only)
            this.$refs.campaignsPanel.step = 2

            //  Check if the campaign is different form the currently selected campaign
            const isNew =
                !this.selectedCampaign || this.selectedCampaign.id != campaign.id

            //  If the campaign is NOT different from the current selected campaign, do nothing
            if (!isNew) return

            //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
            const query = Object.assign({}, this.$route.query)

            //  Update the person query param (there is watcher on this value that handles fetching the person)
            query.id = campaign.id

            //  Update the current url
            this.$router.push({ query })
        },
        onFilterChanged(filter: CampaignFilterParams): void {
            //  Grab the key and value from our filter
            const key = filter.key
            const value = filter.value

            //  Get our current params
            const params = this.campaignsParams

            //  Check if we currently have this filter applied
            const isSame = params[key] === value

            //  If it is the same, do nothing
            if (isSame) return

            //  Else, apply this to our params
            params[key] = value

            //  Set page to 1 since we changed our filter
            params.page = 1

            //  (our computed setter will apply this in the store)
            this.campaignsParams = params

            //  Deselect multiselected items
            this.$refs.campaignsList.multiSelectReset()

            //  The filter was changed so we should paginate the new filter
            this.$store.dispatch('autorespondersCampaignsPaginate')
        },
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.campaignsParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage

            //  (our computed setter will apply this in the store)
            this.campaignsParams = params

            //  Deselect multiselected items
            this.$refs.campaignsList.multiSelectReset()

            //  Paginate the next page
            this.$store.dispatch('autorespondersCampaignsPaginate')
        },
        popCampaignEdit(): void {
            //  Our campaign is the current selected one
            const campaign = this.selectedCampaign

            //  Pop our edit dialog
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Update Autoresponder',
                icon: 'bi-lightning-fill',
                color: 'primary',
                component: 'campaign-form',
                overflow: 'auto',
                props: {
                    campaign: campaign
                },
                callback: (campaign: Campaign): void => this.campaignUpdate(campaign)
            })
        },
        //  Pop a new Autoresponder form
        popNewAutoResponder(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'New Autoresponder',
                icon: 'bi-lightning-fill',
                color: 'primary',
                component: 'campaign-form',
                props: {
                    campaign: this.newAutoResponse(),
                    unassigned: true
                },
                callback: (campaign: Campaign): void => this.campaignCreate(campaign)
            })
        },
        //  The status text displayed as a subtitle to content title
        subtitle(campaign: Campaign): string {
            //  Grab the paused value from our campaign
            const paused = campaign.paused

            //  Assemble default 'active' style
            let status = paused ? 'Paused' : 'Active'
            let icon = 'mdi-circle'
            let style = paused ? `color:${this.$colors.mdYellow}` : `color:#6142b0`

            //  Assemble the html
            const html = `<span><span class="mdi ${icon}" style="${style}"></span><span>${status}</span></span>`

            //  Return the subtitle
            return html
        },
        campaignTile(): IListTile {
            return {
                actionContent: (c: Campaign): IListAction => this.campaignActions(c),
                actionHeader: (c: Campaign): string => this.subtitle(c),
                leftIcon: (c: Campaign) => this.campaignIcon(c),
                line1: (c: Campaign): string => c.name,
                line2: (c: Campaign): string =>
                    `Keyword: <b>${c.subscribe.toUpperCase()}</b>`,
                line3: (c: Campaign): string =>
                    `Created ${this.$options.filters.dateReadable(c.created_at)} ago`,
                callback: (c: Campaign): void => this.onCampaignSelected(c),
                multiSelectHide: (c: Campaign): boolean =>
                    c.required == true ? true : false
            }
        },
        unsetCampaign() {
            //  Unset our campaign
            this.selectedCampaign = null

            //  Unset our group
            this.selectedGroup = null

            //  Grab our current path
            const path = this.$route.path

            //  If we are NOT in campaigns, we are done
            if (!path.includes('auto-responders')) return

            //  Else, replace the id from the router
            this.$router.replace({ id: null })
        }
    },
    watch: {
        $route(to, from): void {
            //  If the 'id' query param does NOT exist, unset our data
            if (!to.query.id) return this.unsetCampaign()

            //  Get the campaign id from the query param
            const id = to.query.id

            //  Check if the 'campaign' param is different from the currently loaded campaign
            const needsLoad = !this.selectedCampaign || id != this.selectedCampaign.id

            //  If we do NOT need to load, do nothing
            if (!needsLoad) return

            //  Else, fetch the new campaign
            this.$store.dispatch('autorespondersSelectedCampaignGet', id)
        },
        selectedCampaign(campaign: Campaign | null): void {
            //  If the campaign was set to null, we need to remove the selected group
            if (!campaign) return this.unsetCampaign()

            //  Else, we need to set our selected group
            this.$store.dispatch('autorespondersSelectedGroupGet', campaign)
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
